import React, { useState } from 'react';
import EstimateCard from './EstimateCard';

const Results = ({ estimates = false, onInquirySubmit, onInquiryValueChange, inquirySent, form, error}) => {

  const [state, setState] = useState({ fullForm: false })

  const resultText = () => {
    if (error) {
      return (
        <div className="alert alert-warning">
          <p>{`We're sorry, an error occured processing your request. ${error}`}</p>
        </div>
      );
    }

    if (inquirySent && !error) {
      return (
        <>
        <div className="alert alert-success">
          <p>Your inquiry has been sent. Check your email for a confirmation.</p>
        </div>
        <button onClick={() => setState({ ...state, fullForm: false })}>Back to Results</button>
        </>
      );
    }
  }

  const renderEstimates = () => {
    if (Object.values(estimates)) {
      return Object.entries(estimates).map(level => (
        level[1].label ? (
            <EstimateCard
                level={level[1].price.railing > 0 ? `${level[1].label} w/ Railing` : level[1].label}
                price={level[1] ? level[1].price.total : 0}
                materials={level[1] ? level[1].materials : {}}
                form={form}
                image={`/wp-content/plugins/deck-cost-calculator/dcc-app/build/estimate_${level[0]}.JPG`}
            />
          )
          : null
      ));
    }

    return null;
  }

  return (
  <div className="results-pane">
    {!state.fullForm ? (
      <>
        {renderEstimates()}
        <p>
        There are several other premium railing that we work with, including Aluminum railing, Cable Railing, and Custom Railing to match your decking color. We also work with other decking products besides Azek & Pressure Treated wood. We would be happy to quote any of these during your No-obligation consultation.
        </p>
        <div className="consultation_btn_wrapper">
          <button className="open_form" onClick={() => setState({ ...state, fullForm: true })}>
            Schedule a no-obligation consultation!
          </button>
        </div>
      </>
    ) : (
      <>
        <h3>Request a consultation</h3>
        <p>To request a no-obligation consultation, fill out the form below completely and we will contact you as soon as possible.</p>
        {error ? (
          <div className="alert alert-warning">
            { `Something went wrong with your request: ${error}` }
          </div>
        ) : null}
        {!inquirySent ? (
          <form className="inquiry_form" id="" onSubmit={onInquirySubmit}>
            <span>
              <label htmlFor="dcc-name">Name*</label>
              <input required id="dcc-name" type="text" name="name" onChange={e => onInquiryValueChange(e.target.value, 'name')}/>
            </span>
            <span>
              <label htmlFor="dcc-email">Email Address*</label>
              <input required id="dcc-email" type="email" name="email" onChange={e => onInquiryValueChange(e.target.value, 'email')}/>
            </span>
            <span>
              <label htmlFor="dcc-zip-code">Zip Code* (5 Number Format)</label>
              <input required pattern="[0-9]{5}" id="dcc-zip-code" type="text" name="zip-code" pattern="^\d{5}((-|\s)\d{4})?$" onChange={e => onInquiryValueChange(e.target.value, 'zip_code')}/>
            </span>
            <span>
              <label htmlFor="dcc-phone">Phone Number</label>
              <input id="dcc-phone" type="text" name="phone" onChange={e => onInquiryValueChange(e.target.value, 'phone')}/>
            </span>
            <span>
              <label htmlFor="dcc-comments">Comments</label>
              <textarea id="dcc-comments" name="comments" onChange={e => onInquiryValueChange(e.target.value, 'comments')}/>
            </span>
            <p>* Required Fields</p>
            <p className="drus-grecaptcha">
              This site is protected by reCAPTCHA and the Google <a href="https://policies.google.com/privacy">Privacy Policy</a> and <a href="https://policies.google.com/terms">Terms of Service</a> apply.
            </p>
            <fieldset className="sdc_fields">
            <button
                type="submit"
            >
              Send Email
            </button>
            <button onClick={() => setState({ ...state, fullForm: false })}>Back to Results</button>
            </fieldset>
          </form>
        ) : (resultText()) }

    </>
    )}
  </div>
  );
}

export default Results;
